import React from 'react'

import { useSearch } from '../../hooks/useSearch'

import { Input } from './Input'

export const SearchInput = ({
  value = '', time, min, placeholder = 'search', onSearch, ...props
}) => {
  const { handleSearch, inputValue } = useSearch({
    time, min, value, onSearch,
  })

  return <Input value={inputValue} placeholder={placeholder} onChange={handleSearch} {...props} />
}
